import { ButtonWrapper } from "./styles";
import { CalendarOutlined, LoadingOutlined } from "@ant-design/icons";
import { Col, Typography } from "antd";
import { ReactSVG } from "react-svg";
import { Spacer } from "../common/Spacer";
import { getTicketCode } from "lib/helpers/ticket";
import React from "react";
import rightArrow from "views/resources/icons/rightArrow.svg";
import videoCall from "views/resources/icons/videoCall.svg";
import usersIcon from "views/resources/icons/usersIcon.svg";
const { Title } = Typography;

const reservationMsj = {
	meet: "Agenda una videollamada para este trámite",
	presencial: "Programa una cita presencial para este trámite",
	mixed: "Agenda una cita presencial o por videollamada",
	face2face: "Programa una cita presencial para este trámite",
};
const ticketMsj = {
	office: "Los tickets virtuales no están disponibles en esta sucursal",
	line: "Los tickets virtuales no están disponibles en esta fila",
};

export const AttentionButton = ({
	isTicketDisabledByOffice,
	attention_type,
	type,
	isDisabled,
	onClick,
	loading,
	ticket,
	navigateToTicketScreen,
	desktop,
	reservation,
	office,
	virtualRoom,
	lineFrozen,
}) => {
	const typeTicket = type === "tickets";
	const handleOnClick = (disabled) => {
		disabled
			? null
			: ticket
			? navigateToTicketScreen()
			: onClick && onClick();
	};

	const textObj = {
		reservation:
			reservationMsj[attention_type] || reservationMsj["presencial"],
		ticket: "Obtén un ticket, te avisamos cuando sea tu turno",
		ticketDisabled: isTicketDisabledByOffice
			? ticketMsj["office"]
			: ticketMsj["line"],
		disabled: "Las reservas no están disponibles en esta fila",
		activeReservation:
			"Solo se permite una reserva, cancélala para agendar otra",
	};

	const ticketText = isDisabled
		? textObj["ticketDisabled"]
		: textObj["ticket"];
	return (
		<ButtonWrapper
			type={type}
			isDisabled={isDisabled}
			onClick={() => handleOnClick(isDisabled)}
			desktop={desktop}
			virtualRoom={virtualRoom}
		>
			{loading && typeTicket ? (
				<div className={"loading_wrapper"}>
					<LoadingOutlined style={{ fontSize: 32 }} />
					<Spacer rows={0.3} />
					<Col>Generando Ticket</Col>
				</div>
			) : (
				<>
					{ticket && !virtualRoom ? (
						<div className={"text__container-with-ticket"}>
							<Col>Tu número de ticket:</Col>
							<Title level={1}>{getTicketCode(ticket)}</Title>
						</div>
					) : (
						<>
							{typeTicket && virtualRoom ? (
								<ReactSVG
									src={ticket ? rightArrow : videoCall}
									className="waitingRoomIcon"
								/>
							) : typeTicket ? (
								<ReactSVG src={usersIcon} />
							) : (
								<CalendarOutlined style={{ fontSize: 26 }} />
							)}
							<div className={"text__button-container"}>
								<Title level={5}>
									{virtualRoom && ticket && !lineFrozen
										? "Ingresa a la sala de espera virtual"
										: virtualRoom &&
										  typeTicket &&
										  lineFrozen
										? "Fila virtual no disponible"
										: virtualRoom && typeTicket
										? "Unirme a la fila virtual"
										: typeTicket
										? "Unirse a la fila"
										: "Reservar atención"}
								</Title>
								<Col
									hidden={virtualRoom && typeTicket}
								>
									{isDisabled &&
									!typeTicket &&
									!reservation
										? textObj["disabled"]
										: typeTicket
										? ticketText
										: reservation
										? textObj["activeReservation"]
										: textObj["reservation"]}
								</Col>
							</div>
						</>
					)}
				</>
			)}
		</ButtonWrapper>
	);
};
